import { ICONS } from '@ui/icons/types';
import { TBroadcastTypePickerOptions } from './broadcast-type-picker.types';
import { EBroadcastTypes } from '@/types/session.types';
import ProjectColorIcon from '@ui/icons/icon/project-color-icon';

const getBroadcastTypeIcon = (broadcastType: TBroadcastTypePickerOptions, size: number = 16) => {
  switch (broadcastType) {
    case EBroadcastTypes.greenroom:
      return <ProjectColorIcon name={ICONS.TELLY} size={size} />;
    case EBroadcastTypes.rtmps:
      return <ProjectColorIcon name={ICONS.RTMP} size={size} />;
    case 'teams':
      return <ProjectColorIcon name={ICONS.PEOPLE} size={size} />;
    case 'zoom':
      return <ProjectColorIcon name={ICONS.VIDEO} size={size} />;
  }
};

export default getBroadcastTypeIcon;
